import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const shoppingListAccessControl: DomainAccessControlConfig = [
  {
    permissions: [
      Permission.ShoppingListShoppingListView,
      Permission.ShoppingListShoppingListModify,
    ],
    featureToggles: FeatureToggle.ShoppingList,
  },
  {
    permissions: [
      Permission.ShoppingListShoppingListView,
      Permission.ShoppingListShoppingListModify,
    ],
    warehouseFeatureToggles: FeatureToggle.ShoppingList,
  },
]
